import React, { Fragment, useState } from 'react';
import { useTranslate, useRecordContext, required, useNotify, Button,
        SimpleForm, useRefresh, TextInput, } from 'react-admin';
import NoDeleteToolbar from '../../lib/NoDeleteToolbar';
import IconFileCopy from '@mui/icons-material/FileCopy';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import dataProvider from '../dataProvider';

const OnlineCopy = (props) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const record = useRecordContext();

  const [showDialog, setShowDialog] = useState(false);
  
  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const doSave = (data) => {
    dataProvider.update('calOnline', { id:record.id, data:data })
      .then(({ data }) => {
        setShowDialog(false);
        refresh();
      })
      .catch(error => {
        notify(error.message, 'error');
      })
      .finally(() => {
        // Dispatch an action letting react-admin know a API call has ended
      });
  };

  const translate = useTranslate();
  const prefill = 'Copy of '+(record?record.bezeichnung:'');
  return (
    <Fragment>
      <Button onClick={handleClick} label="glob.copy">
        <IconFileCopy />
      </Button>
      <Dialog fullWidth open={showDialog} onClose={handleCloseClick} aria-label="bw.cal.online.copytitle" >
        <DialogTitle>{translate("bw.cal.online.copytitle")}</DialogTitle>
        <DialogContent>
          <SimpleForm resource="calOnline" onSubmit={doSave} toolbar={<NoDeleteToolbar />} >
            <Fragment>
              <h3>{record?record.bezeichnung:''}</h3>
              <div>{translate('bw.cal.online.copyinfo')}</div>
            </Fragment>
            <TextInput source="copyTitle" defaultValue={prefill} validate={required()} />
          </SimpleForm>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}

export default OnlineCopy;

